class BenefitsAccordion {
	constructor(passedElement) {
		let self = this;

		self.elem = passedElement;
	}

	init() {
		let self = this;

		const button = self.elem.querySelector('.js-benefits-btn');
		const content = self.elem.querySelector('js-benefits-content');

		button.addEventListener('click', evt => {
			evt.preventDefault();

			if(self.elem.classList.contains('active')) {
				self.elem.classList.remove('active');
			} else {
				self.elem.classList.add('active');
			}
		});
	}
}

export default BenefitsAccordion;